/**
 * Sticky Map Module
 * JavaScript-based sticky behavior for the map on mobile devices
 */

export function initStickyMap(): void {
  const mapWrapper = document.querySelector<HTMLElement>('.map-section__image-wrapper');
  const mapSection = document.querySelector<HTMLElement>('.map-section');
  const listWrapper = document.querySelector<HTMLElement>('.map-section__list-wrapper');

  if (!mapWrapper || !mapSection || !listWrapper) return;

  let isSticky = false;
  let placeholder: HTMLElement | null = null;
  let mapHeight = 0;
  let ticking = false;

  const isMobile = (): boolean => window.innerWidth <= 768;

  const makeSticky = (): void => {
    mapHeight = mapWrapper.offsetHeight;

    // Create placeholder
    placeholder = document.createElement('div');
    placeholder.className = 'map-section__sticky-placeholder';
    placeholder.style.height = mapHeight + 'px';
    mapWrapper.parentNode!.insertBefore(placeholder, mapWrapper);

    // Position map fixed
    mapWrapper.classList.add('is-sticky-js');
    isSticky = true;
  };

  const removeSticky = (): void => {
    mapWrapper.classList.remove('is-sticky-js');

    if (placeholder) {
      placeholder.remove();
      placeholder = null;
    }

    isSticky = false;
  };

  const updateStickyState = (): void => {
    if (!isMobile()) {
      // Desktop: Remove sticky
      if (isSticky) {
        removeSticky();
      }
      return;
    }

    const sectionRect = mapSection.getBoundingClientRect();
    const currentMapHeight = isSticky ? mapHeight : mapWrapper.offsetHeight;

    // Map should be sticky when:
    // 1. The section has reached the top edge
    // 2. The section hasn't scrolled up so far that the map should leave
    const shouldBeSticky = sectionRect.top <= 0 && sectionRect.bottom > currentMapHeight;

    if (shouldBeSticky && !isSticky) {
      makeSticky();
    } else if (!shouldBeSticky && isSticky) {
      removeSticky();
    }

    ticking = false;
  };

  const onScroll = (): void => {
    if (!ticking) {
      window.requestAnimationFrame(updateStickyState);
      ticking = true;
    }
  };

  const onResize = (): void => {
    if (isSticky) {
      removeSticky();
    }
    updateStickyState();
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onResize, { passive: true });

  // Initial check
  updateStickyState();
}
